import { Component, EventEmitter, Input, OnInit, Output, ViewChild, ViewEncapsulation } from '@angular/core';
import { TransporterService } from '../../../services/transporter.service';
import { Authority } from '../../config/authority.constants';
import { HttpResponse } from '@angular/common/http';
import { AccountService } from '../../../services/account.service';
import { SidenavComponent } from 'ng-uikit-pro-standard';
import { Transporter } from '../../../models/transporter.model';
import { environment } from '../../../environments/environment';
import { User } from '../../../models/user.model';

@Component({
  selector: 'jhi-bary-sidebar',
  templateUrl: './bary-sidebar.component.html',
  styleUrls: ['./bary-sidebar.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class BarySidebarComponent implements OnInit {
  @Input() transporter!: Transporter;
  @Input() account!: User;
  @Input() isImpersonating = false;
  @Input() swaggerEnabled = true;
  @Input() inProduction = false;
  @Output() goToEvent = new EventEmitter<string>();
  @ViewChild('sidenav') sidenav!: SidenavComponent;

  _authority = Authority;
  transporters: Transporter[] = [];
  logo = `${environment.urlApi}api/img/logo-main`;

  constructor(protected transporterService: TransporterService, private accountService: AccountService) {}

  ngOnInit(): void {
    if (this.accountService.hasAnyAuthority('ROLE_ADMIN')) {
      this.transporterService.query().subscribe((res: HttpResponse<Transporter[]>) =>
        (this.transporters = res.body ?? []).sort((a, b) =>
          (a.technicalName ?? '')
            .trim()
            .toLowerCase()
            .localeCompare((b.technicalName ?? '').trim().toLowerCase())
        )
      );
    }
  }

  handleGoTo(path: string): void {
    this.goToEvent.emit(path);
  }

  hasRole(role: string): boolean {
    return this.account?.authorities?.includes(role);
  }

  hasOnlyRole(role: string): boolean {
    return this.hasRole(role) && this.account.authorities.length === 1;
  }
}
